<div *ngIf="inProgress">
    <div class="progress-container" [ngClass]="size">
        <div class="inline-loader"></div>
    </div>
    <span *ngIf="label" class="loader-text">{{ label }}</span>
</div>

